"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Styled = __importStar(require("./LinkStyles"));
var react_router_dom_1 = require("react-router-dom");
var react_feather_1 = require("react-feather");
var Link = function (_a) {
    var children = _a.children, href = _a.href, _b = _a.variant, variant = _b === void 0 ? "subtle-green" : _b, _c = _a.target, target = _c === void 0 ? "_self" : _c, as = _a.as, to = _a.to, backgroundColor = _a.backgroundColor, inline = _a.inline, size = _a.size, props = __rest(_a, ["children", "href", "variant", "target", "as", "to", "backgroundColor", "inline", "size"]);
    if (as === "NavLink") {
        return (React.createElement(react_router_dom_1.NavLink, __assign({ to: to }, props, { style: { textDecoration: "none" } }),
            React.createElement(Styled.NavLinkContent, { variant: variant, backgroundColor: backgroundColor, inline: inline, size: size },
                React.createElement("span", null, children),
                variant === "primary" && React.createElement(react_feather_1.ArrowRight, { className: "icon" }))));
    }
    else {
        return (React.createElement(Styled.Link, __assign({ variant: variant, href: href, target: target, backgroundColor: backgroundColor, inline: inline, size: size }, props),
            React.createElement("span", null, children),
            variant === "primary" && React.createElement(react_feather_1.ArrowRight, { className: "icon" })));
    }
};
exports.default = Link;
